module.exports = __webpack_public_path__ + "static/logo-cbb51b159827106e0053a0b7c30cdedb.png";